import { baseTheme } from 'base-theme';

import { createTheme } from '@mui/material';
import type {} from '@mui/x-data-grid/themeAugmentation';
import { ColorBlue, ColorBluViu } from './theme-colors';

// ---------------------------------------------------
// Specific Theme Configurations (Salmon & Shrimp)
// ---------------------------------------------------
export const salmonTheme = createTheme(baseTheme, {
  components: {
    MuiCssBaseline: {
      styleOverrides: (themeParam: { palette: { darkBlue: { main: string } } }) => ({
        body: {
          //The scrollbar overide needs to be in the theme and not in base theme orelse it wont show
          scrollbarColor: `${themeParam.palette.darkBlue.main} transparent`,
          '&::-webkit-scrollbar, & *::-webkit-scrollbar': {
            width: 8,
            height: 8,
            backgroundColor: 'transparent',
            borderTopRightRadius: 8,
            borderBottomRightRadius: 8,
          },
          '&::-webkit-scrollbar-thumb, & *::-webkit-scrollbar-thumb': {
            borderRadius: 8,
            backgroundColor: `${themeParam.palette.darkBlue.main}`,
          },
          '&::-webkit-scrollbar-thumb:focus, & *::-webkit-scrollbar-thumb:focus': {
            backgroundColor: themeParam.palette.darkBlue.main,
          },
          '&::-webkit-scrollbar-thumb:active, & *::-webkit-scrollbar-thumb:active': {
            backgroundColor: themeParam.palette.darkBlue.main,
          },
          '&::-webkit-scrollbar-thumb:hover, & *::-webkit-scrollbar-thumb:hover': {
            backgroundColor: themeParam.palette.darkBlue.main,
          },
          '&::-webkit-scrollbar-corner, & *::-webkit-scrollbar-corner': {
            backgroundColor: themeParam.palette.darkBlue.main,
          },
          '$::webkit-scrollbar-button': {
            display: 'none',
          },
          background: `linear-gradient(to bottom, #017158, #00625a, #005357, #004450, #003544, #002f3e, #012837, #012231, #012231, #012231, #012231, #012231);`, // salmon
        },
      }),
    },
    MuiChip: {
      styleOverrides: {
        root: {
          color: ColorBlue.dark,
          backgroundColor: ColorBlue.main,
        },
      },
    },
    MuiIconButton: {
      styleOverrides: {
        colorPrimary: {
          '&:hover': {
            backgroundColor: ColorBluViu.o50,
          },
          '@media (hover: none)': {
            '&:hover': {
              backgroundColor: `#93cab7 !important`,
            },
          },
        },
      },
    },
    MuiAlert: {
      styleOverrides: {
        standardInfo: {
          color: '#fff',
          '& .MuiAlert-icon': {
            color: ColorBlue.main,
          },
          '& .MuiSvgIcon-root': {
            fill: ColorBlue.main,
          },
          '& .MuiAlert-action': {
            alignItems: 'start',
          },
        },
      },
    },
  },
});

export const shrimpTheme = createTheme(baseTheme, {
  components: {
    MuiCssBaseline: {
      styleOverrides: (themeParam: { palette: { darkBlue: { main: any } } }) => ({
        //The scrollbar overide needs to be in the theme and not in base theme orelse it wont show
        body: {
          scrollbarColor: `${themeParam.palette.darkBlue.main} transparent`,
          '&::-webkit-scrollbar, & *::-webkit-scrollbar': {
            width: 8,
            height: 8,
            backgroundColor: 'transparent',
            borderTopRightRadius: 8,
            borderBottomRightRadius: 8,
          },
          '&::-webkit-scrollbar-thumb, & *::-webkit-scrollbar-thumb': {
            borderRadius: 8,
            backgroundColor: `${themeParam.palette.darkBlue.main}`,
          },
          '&::-webkit-scrollbar-thumb:focus, & *::-webkit-scrollbar-thumb:focus': {
            backgroundColor: themeParam.palette.darkBlue.main,
          },
          '&::-webkit-scrollbar-thumb:active, & *::-webkit-scrollbar-thumb:active': {
            backgroundColor: themeParam.palette.darkBlue.main,
          },
          '&::-webkit-scrollbar-thumb:hover, & *::-webkit-scrollbar-thumb:hover': {
            backgroundColor: themeParam.palette.darkBlue.main,
          },
          '&::-webkit-scrollbar-corner, & *::-webkit-scrollbar-corner': {
            backgroundColor: themeParam.palette.darkBlue.main,
          },
          '$::webkit-scrollbar-button': {
            display: 'none',
          },
          background:
            'linear-gradient(to bottom, #004a98, #004485, #003c71, #00355d, #002d4a, #002a42, #002639, #012231, #012231, #012231, #012231, #012231);', // shrimp
        },
      }),
    },
    MuiChip: {
      styleOverrides: {
        root: {
          color: '#ffffff',
          backgroundColor: ColorBlue.main,
        },
      },
    },
    MuiIconButton: {
      styleOverrides: {
        colorPrimary: {
          '&:hover': {
            backgroundColor: '#93cab7',
          },
          '@media (hover: none)': {
            '&:hover': {
              backgroundColor: `#93cab7 !important`,
            },
          },
        },
      },
    },
  },
});
